import React from 'react';
import EmailBulkModal from './EmailBulkModal';

export default function EmailCombinedPdfPopup(args) {
  return <EmailBulkModal {...args} topBarTitle="Email Combined PDFs" emailActionName="emailPartsPdfCombined" />;
}



// WEBPACK FOOTER //
// ./src/components/case/docket/popups/EmailCombinedPdfPopup.jsx